import Api from './Api';

export default class FaqsCategoriasApi {

  all = async () => {
    return await Api.get('faqscategorias').then(response => {
      return response.data;
    }).catch(error => console.log('[FaqsCategoriasApi][categorias]: Error\n', error));
  };

  faqs = async (id) => {
    return await Api.get(`faqscategorias/faqs/${id}`).then(response => {
      return response.data;
    }).catch(error => console.log('[FAQSCATEGORIASAPI][FAQS]: ERROR\n', error));
  };
}